import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { FILTER_DATA_LIST_RESPONSE } from "../types/ResponseTypes";
import { GET_FILTER_CASE_ID_QUERY_KEY, GET_FILTER_QUERY_KEY } from "../types/CommonTypes";

type FilterContextParams = {
  startDate: string;
  endDate: string;
  ots?: string;
  procedureIds?: string;
  attendingSurgeonNames?: string;
  nurseIds?: string;
  assignedAnesthesiologist?: string;
  delayCategories?: string;
};

async function getFilterCaseIdData(params: FilterContextParams): Promise<FILTER_DATA_LIST_RESPONSE> {
  const { data } = await fetcher({
    url: "analytics/filter-options/case-ids",
    params, 
  });
  return data?.options || [];
}

export function useGetFilterCaseIdQuery(params: FilterContextParams | undefined, enabled: boolean = false) {
  return useQuery({
    queryKey: [GET_FILTER_QUERY_KEY, GET_FILTER_CASE_ID_QUERY_KEY, params],
    queryFn: () => getFilterCaseIdData(params as FilterContextParams),
    enabled: enabled && !!params,
    staleTime: 5 * 60 * 1000,
  });
}
